/**
 * Service worker registration for Acountix PWA.
 * - Only registers in production build OR when explicitly enabled via ?sw=1
 * - Dev-mode (localhost / hot reload) skips by default to avoid stale cache surprises
 */
export function registerServiceWorker() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;

  const params = new URLSearchParams(window.location.search);
  const forceOn = params.get('sw') === '1';
  const isProd = process.env.NODE_ENV === 'production';
  if (!isProd && !forceOn) return;

  // iter 318 — új verzió: amint az új SW átveszi az irányítást, egyszer újratöltünk (fehér képernyő / régi bundle ellen)
  let reloaded = false;
  const hadController = !!navigator.serviceWorker.controller;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (reloaded || !hadController) return;
    reloaded = true;
    window.location.reload();
  });

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => {
        // eslint-disable-next-line no-console
        console.info('[Acountix] SW registered', reg.scope);
        const check = () => reg.update().catch(() => {});
        document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') check(); });
        setInterval(check, 30 * 60 * 1000);
        reg.addEventListener('updatefound', () => {
          const nw = reg.installing;
          if (!nw) return;
          nw.addEventListener('statechange', () => { if (nw.state === 'installed' && navigator.serviceWorker.controller) nw.postMessage({ type: 'SKIP_WAITING' }); });
        });
      })
      .catch(() => {
        // Silent; SW is progressive enhancement
      });
  });
}

export function unregisterServiceWorker() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((r) => r.unregister());
  });
}
